<template>
  <div class="WechatUsers app-container">
    <el-card shadow="never">
      <header>
        <el-button
          type="primary"
          style="margin-right: 100px;"
          @click="$refs.addServiceProvider.open(null, 1)"
        >创建服务商</el-button>
      </header>
      <main>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="180"
          />
          <el-table-column
            prop="service_name"
            label="服务商名称"
            width="300"
          />
          <el-table-column
            prop="account"
            label="服务商账号"
          />
          <el-table-column
            prop="bm_id"
            label="bm_id"
          />
          <el-table-column
            prop="date"
            label="操作"
            width="150"
            align="center"
          >
            <template scope="scope">
              <el-button
                size="mini"
                @click="$refs.addServiceProvider.open(scope.row, 2)"
              >修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </main>
      <add-modify-service-provider
        ref="addServiceProvider"
        :select-data="tableData"
        @addConfirm="addServiceProviderConfirm"
        @modifyConfirm="modifyServiceProviderConfirm"
      />
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, modifyServiceProvider, addServiceProvider } from '@/api/providerAccountManagement/servicePorviderList'
import AddModifyServiceProvider from './components/AddModifyServiceProvider'
export default {
  name: 'ServicePorviderList',
  components: {
    PaginationRight,
    AddModifyServiceProvider
  },
  data() {
    return {
      tableData: {}, // 获取的列表数据
      serviceProvidersListQuery: {
        page: null,
        page_size: null
      },
      addServiceProviderQuery: {
        service_name: null,
        account: null
      },
      modifyServiceProviderQuery: {
        id: null,
        service_name: null
      },
      data: {},
      total: null,
      loading: false // 加载效果
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.loading = true
      getList(this.serviceProvidersListQuery).then(res => {
        this.tableData = res.data
        this.total = res.data.total
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.serviceProvidersListQuery.page_size = e
      console.log(e)
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.serviceProvidersListQuery.page = e
      this.getListData()
    },
    // 创建服务商
    addUserConfirm(data) {
      addServiceProvider(data).then(res => {
        this.getListData()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
      })
    },
    // 修改服务商
    modifyServiceProviderConfirm(id, data) {
      modifyServiceProvider(id, data).then(res => {
        this.getListData()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    },
    // 创建服务商
    addServiceProviderConfirm(data) {
      addServiceProvider(data).then(res => {
        this.getListData()
        this.$message({
          message: '提交成功',
          type: 'success'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.WechatUsers {
  min-width: 1200px;
  // padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
